import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Car } from 'lucide-react';
import type { City } from '@/data/cities';

interface Props { city: City }

const VilleHero = ({ city }: Props) => (
  <section className="relative bg-petrol py-20 md:py-28 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-petrol via-petrol to-petrol-light/20" />
    <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
      <p className="text-petrol-foreground/50 text-sm font-heading mb-2">
        <Link to="/" className="hover:text-petrol-foreground transition-colors">Accueil</Link>
        {' › '}
        <span>Agence événementielle {city.prefix} {city.name}</span>
      </p>
      <h1 className="font-heading text-3xl md:text-5xl font-black text-petrol-foreground leading-tight mb-2">
        Agence événementielle {city.prefix} {city.name}
      </h1>
      <p className="font-heading text-2xl md:text-3xl font-black text-primary leading-tight mb-6">
        Cygnature Production — Troyes
      </p>
      <p className="text-petrol-foreground/70 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-6">
        {city.heroSubtitle}
      </p>

      {/* Distance info */}
      <div className="flex items-center justify-center gap-2 text-petrol-foreground/60 text-sm mb-8">
        <Car size={16} className="text-primary shrink-0" strokeWidth={1.5} />
        <span>
          À seulement <strong className="text-petrol-foreground font-heading font-bold">{city.distanceKm} km</strong> — <strong className="text-petrol-foreground font-heading font-bold">{city.driveTime} en voiture</strong>
        </span>
      </div>

      <div className="flex flex-wrap justify-center gap-3">
        <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary text-primary-foreground font-heading font-medium text-sm hover:bg-primary/90 transition-colors">
          Devis gratuit <ArrowRight size={15} />
        </Link>
        <a href="tel:+33671351550" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-petrol-foreground/20 text-petrol-foreground font-heading font-medium text-sm hover:bg-petrol-foreground/10 transition-colors">
          <Phone size={15} /> 06 71 35 15 50
        </a>
      </div>
    </div>
  </section>
);

export default VilleHero;
